import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { OndernemingService } from 'src/app/services/onderneming.service';
import { FormBuilder, Validators } from '@angular/forms';
import { HolidayValueService } from 'src/app/services/Holiday-value.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'src/app/services/data.service';
import { IFormGroup, IFormBuilder } from '@rxweb/types';
import { HolidayValue } from 'src/app/models/HolidayValue';
import { mergeMap, take } from 'rxjs/operators';
import { ModalContentComponent } from 'src/app/shared/modal-content/modal-content.component';
import { ToastComponent } from 'src/app/shared/toast/toast.component';
import { Onderneming } from 'src/app/models/Onderneming';
@Component({
  selector: 'app-admin-holiday-value',
  templateUrl: './admin-holiday-value.component.html',
  styleUrls: ['./admin-holiday-value.component.scss']
})
export class AdminHolidayValueComponent implements OnInit {
  @Input() ondernemingNaam: string;
  formBuilder: IFormBuilder;
  holidayValueFormGroup: IFormGroup<HolidayValue>;
  onderneming: Onderneming;
  saved:Boolean = false;
  err = [ "Dit veld is verplicht."];
  holidayValue: HolidayValue = {
    berekeningMaandloon:"",
    berekeningUurloon:"",

  }
  constructor(
    private holidayValueService: HolidayValueService,
      formBuilder: FormBuilder,
    private modalService: NgbModal,
    public dataService: DataService,
    private cdref: ChangeDetectorRef,
    


  ) {
       this.formBuilder = formBuilder
      
    }
   
  ngOnInit(): void {
    this.holidayValueFormGroup = this.formBuilder.group<HolidayValue>({
      berekeningMaandloon: this.formBuilder.control(null,[Validators.required]),
      berekeningUurloon: this.formBuilder.control(null,[Validators.required]),
  
    })
 this.getData(this.ondernemingNaam);
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
 }
  getData(ondernemingNaam:string)
  {
    // if (this.dataService.onderneming == undefined || this.dataService.onderneming.naam.toLowerCase() != ondernemingNaam.toLowerCase()) {
      
    //   this.ondernemingService.getOnderneming(ondernemingNaam).pipe(
    //     mergeMap((onderneming) => {
    //       this.dataService.onderneming = onderneming;
    //       localStorage.setItem('onderneming', JSON.stringify(this.dataService.onderneming.naam));
    //       console.log("laden van onderneming");
    //       return this.holidayValueService.getHolidayValue(this.dataService.onderneming?.holidayValue);
    //     }),
    //     take(1))
    //     .subscribe(e => {

    //       this.holidayValue = e;
    //       err => console.log(err);
    //     });
    // }
    // else {
    //   this.getHolidayValue(this.dataService.onderneming.holidayValue);
    // }
    this.onderneming = this.dataService?.getOnderneming();
    this.getHolidayValue(this.onderneming.holidayValue);
  }
  getHolidayValue(id: string) {
    if (this.dataService.holidayValue== undefined) {
      this.holidayValueService.getHolidayValue(id).pipe(
        take(1))
        .subscribe(e => {
          this.holidayValue = e;
          this.cdref.markForCheck();
          // this.setValue();
        });
    }
    else
    {
      this.holidayValue = this.dataService.holidayValue;
    }
    
  }
  async onSubmit() {
    if (this.holidayValueFormGroup.invalid) {
       return;
     }
    const modalRef = this.modalService.open(ModalContentComponent);
    modalRef.componentInstance.confirmationBoxTitle = 'Bevestiging';
    modalRef.componentInstance.confirmationMessage = 'Weet u zeker dat u deze gegevens wilt opslaan?';

    const userResponse = await modalRef.result;
    if (userResponse) {
      this.opslaan();
    }
  }
  opslaan()
  {
      this.holidayValueService.updateHolidayValue(this.holidayValue);  
      

  }

}
